import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogContent, IconButton } from "@mui/material";
import closeButton from "../../Assets/popup-close.svg";
//import WorkflowTemplateServiceController from "../../Controllers/WorkflowTemplateController/WorkflowTemplateservice";

const NoLevelPopup = ({ openConfirmationPopup, onClose, handleClickRedirect }) => {

  const handleClose = () => onClose();
  var Spinner = require('react-spinkit');

  const handleDeleteRow = async (uniqueId) => {
    console.log("Deleting function from popup called: ", uniqueId);
    // handleDeleteTemplate(uniqueId);
  };
  
  const handlePublishClick = async (uniqueId) => {
    console.log("publishing from popup called: ", uniqueId);
    //handlePublishTemplate(uniqueId);
  };

  const handleClickEvent = (type, id) => {
    switch (type) {
      case "delete":
        handleDeleteRow(id);
        break;
      case "publish":
        handlePublishClick(id);
        break;
      default:
        console.log("no function defined for click event inside confirmation popup");
        break;
    }
  };

  return (
    <Dialog
      open={openConfirmationPopup}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, // Adjust the opacity here
        },
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 5px",
          }}
        >
          <p>Warning</p>
          <IconButton onClick={handleClose}>
            <img src={closeButton} alt="close-button" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        NO levels for this workflow
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: 'fit-content' }}>
          <Button
            variant="contained"
            style={{ backgroundColor: "#02ACF6", textTransform: 'capitalize', height: '37px', width: 'auto' }}
            onClick={handleClickRedirect}
            className="dialog-save-button"
          >
            Subflow Template List
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "#757ea5", textTransform: "none" }}
            onClick={handleClose}
            className="dialog-save-button"
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NoLevelPopup;
